import { useMediaQuery } from "@mui/material";

/** Mobile / phone breakpoint — matches AppFooter and common md threshold. */
export const MOBILE_BREAKPOINT = 768;

/**
 * True when viewport is below the mobile breakpoint.
 * Uses MUI useMediaQuery so layout updates stay in sync with CSS.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width:${MOBILE_BREAKPOINT - 1}px)`);
}
